// Geliştirme kolaylığı: aynı tarayıcıda birden fazla hesapla aynı anda
// oturum açabilmek için auth anahtarlarını sessionStorage öncelikli,
// localStorage yedekli okumaya yönlendirir.
//
// Davranış (yalnızca AUTH_KEYS için):
//   localStorage.getItem(key)    → sessionStorage'da varsa onu, yoksa localStorage'i döner
//   localStorage.setItem(key, v) → her ikisine de yazar (yeni sekmeler son aktif token'ı görsün)
//   localStorage.removeItem(key) → her ikisinden de siler
//
// Sonuç:
//   - Tab 1: A olarak giriş yap → bu tab'ın sessionStorage'ı = A; localStorage = A
//   - Tab 2 (yeni) → kendi sessionStorage'ı boş; localStorage = A → A görür
//     - Çıkış yap, B olarak giriş yap → Tab 2 sessionStorage'ı = B; localStorage = B (üzerine yazılır)
//     - Tab 1 hâlâ kendi sessionStorage'ında A ile oturumda kalır.
//   - Sekme kapatılırsa o tab'ın session'ı düşer; tekrar açıldığında localStorage'deki
//     son aktif kullanıcıyla geri gelir.
//
// AUTH_KEYS dışındaki tüm localStorage erişimi olduğu gibi çalışır.

const AUTH_KEYS = new Set(['projabze_token', 'projabze_user']);

const proto = Storage.prototype;
const _getItem = proto.getItem;
const _setItem = proto.setItem;
const _removeItem = proto.removeItem;

proto.getItem = function (key) {
  if (this === window.localStorage && AUTH_KEYS.has(key)) {
    const fromSession = _getItem.call(window.sessionStorage, key);
    if (fromSession != null) return fromSession;
    return _getItem.call(window.localStorage, key);
  }
  return _getItem.call(this, key);
};

proto.setItem = function (key, value) {
  if (this === window.localStorage && AUTH_KEYS.has(key)) {
    _setItem.call(window.sessionStorage, key, value);
    _setItem.call(window.localStorage, key, value);
    return;
  }
  return _setItem.call(this, key, value);
};

proto.removeItem = function (key) {
  if (this === window.localStorage && AUTH_KEYS.has(key)) {
    _removeItem.call(window.sessionStorage, key);
    _removeItem.call(window.localStorage, key);
    return;
  }
  return _removeItem.call(this, key);
};
